<script>
export default {
	name: 'WurldDynamicTag',
	props: {
		tag: {
			required: true,
			type: String
		}
	},
	render (createElement) {
		return createElement(
			this.tag,
			this.$slots.default
		);
	}
};
</script>
